import http from "./httpService";
import urlConstant from "../constants/url-constants";

export async function getUserHmaUserProductionOrderItems(userId) {
    return http.post(urlConstant.getUserProductionOrderItemsEndpoint(), { userId: userId }, http.getAuthorizedConfig());
}

export async function getUserHmaUserProfile(userId) {
    return http.post(urlConstant.getUserProfileInfoEndpoint(), { userId: userId }, http.getAuthorizedConfig());
}

export async function getUserHmaUserProfileSupportRequests(userId) {
    return http.post(urlConstant.getUserProfileSupportRequestsEndpoint(), { userId: userId }, http.getAuthorizedConfig());
}

export async function getDataSheet(partCode) {
    return http.post(urlConstant.getDataSheetByPartCodeEndpoint(), { partCode: partCode }, http.getAuthorizedConfig());
}
export async function getProductionOrderRunTime(userId, serial) {
    return http.post(urlConstant.getProductionOrderRunTimeBySerialEndpoint(), { userId: userId, serial: serial }, http.getAuthorizedConfig());
}

export default {
    getUserHmaUserProductionOrderItems,
    getUserHmaUserProfile,
    getUserHmaUserProfileSupportRequests,
    getDataSheet,
    getProductionOrderRunTime
};